import { AfterViewInit, Component, Inject, OnDestroy, OnInit, DOCUMENT } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subject, takeUntil } from 'rxjs';
import { TelegramService } from '../shared/services/telegram.service';
import { HeroComponent } from './components/hero/hero.component';
import { RatesComponent } from './components/rates/rates.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { OfficeComponent } from './components/office/office.component';
import { BackToTopComponent } from '../shared/components/back-to-top/back-to-top.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { HowItWorkComponent } from './components/how-it-work/how-it-work.component';
import { ReasonsWhyUsComponent } from './components/reasons-why-us/reasons-why-us.component';
import { NoticeComponent } from './components/notice/notice.component';
import { DidNotEnoughComponent } from './components/did-not-enough/did-not-enough.component';
import { AboutUsComponent } from './components/about-us/about-us.component';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    HeroComponent,
    RatesComponent,
    ContactUsComponent,
    OfficeComponent,
    TestimonialsComponent,
    HowItWorkComponent,
    ReasonsWhyUsComponent,
    NoticeComponent,
    BackToTopComponent,
    DidNotEnoughComponent,
    AboutUsComponent,
  ],
})
export class LandingComponent implements OnInit, AfterViewInit, OnDestroy {
  fragment: string | null = null;

  private readonly destroySubject = new Subject();

  constructor(
    private route: ActivatedRoute,
    private tg: TelegramService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  async ngOnInit() {
    this.route.fragment.pipe(takeUntil(this.destroySubject)).subscribe((fragment) => {
      this.fragment = fragment;
      this.scrollToFragment();
    });
  }

  ngAfterViewInit(): void {
    this.scrollToFragment();
    this.route.queryParams.subscribe(async (qs) => {
      if (qs['syncData']) {
        await this.tg.syncUserData();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroySubject.next(true);
  }

  private scrollToFragment() {
    try {
      this.document?.querySelector('#' + this.fragment)?.scrollIntoView({
        behavior: 'smooth',
      });
    } catch (e) {}
  }
}
